import { NSARouterMakerResult } from 'namirasoft-account-react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import RetrieveValueDialog from '../components/RetrieveValueDialog';
import { SecretEntities } from '../SecretEntities';
import { SecretLayout } from '../SecretLayout';
import { SecretRouterProps } from '../SecretRouterProps';

interface SecretViewPageProps extends NSARouterMakerResult, SecretRouterProps { }

interface SecretViewPageState
{
	show_retrieve_value: boolean;
}

function SecretViewPage(props: SecretViewPageProps)
{
	let [state, setState] = useState<SecretViewPageState>({ show_retrieve_value: false });

	let params = useParams();

	return (
		<>
			<SecretLayout
				{...props}
				action={{
					title: "",
					description: "Examine secret details to modify, edit, it. You can choose to retrieve its value, too.",
					menus: {}
				}}
				pages={{
					entity: SecretEntities.secret(props, () =>
					{
						setState(prevState => ({ ...prevState, show_retrieve_value: true }));
					}),
					view: {}
				}}
			>
				<></>
			</SecretLayout>

			{
				state.show_retrieve_value &&
				<RetrieveValueDialog
					{...props}
					id={params.id ?? ""}
					onClose={() =>
					{
						setState(prevState => ({ ...prevState, show_retrieve_value: false }));
					}}
				/>
			}
		</>
	);
}

export default SecretViewPage;